import { getCurrentUserDomainName } from '../../../utils/domainUtils';
import { useFileStorage } from './useFileStorage';
import { useHTMLViewer } from './useHTMLViewer';
import { useFlashCheckTabs } from './useFlashCheckTabs';
import { useUploadState } from './useUploadState';

export const useFlashCheck = () => {
  // Focused hooks
  const fileStorage = useFileStorage();
  const htmlViewer = useHTMLViewer();
  const tabs = useFlashCheckTabs(fileStorage.files);
  const upload = useUploadState();

  // Get domain name from user email
  const getDomainName = getCurrentUserDomainName;

  // Composed handlers that bridge between hooks
  const handleItemClick = (item: any) => {
    htmlViewer.handleItemClick(item, (path: string) => {
      fileStorage.setCurrentPath(path);
      fileStorage.loadFiles(path);
    });
  };

  const handleUploadComplete = () => {
    upload.handleUploadComplete(() => fileStorage.loadFiles(fileStorage.currentPath));
  };

  // Combine errors from different hooks
  const error = fileStorage.error || htmlViewer.error;
  const clearError = () => {
    fileStorage.clearError();
    htmlViewer.setError(null);
  };

  // Combined loading state
  const loading = fileStorage.loading || htmlViewer.loadingFileUrl;

  return {
    // State from file storage
    files: fileStorage.files,
    currentPath: fileStorage.currentPath,
    loading,
    error,
    
    // State from tabs
    activeTab: tabs.activeTab,
    getFilteredFiles: tabs.getFilteredFiles,
    handleTabChange: tabs.handleTabChange,
    
    // State from upload
    uploadSuccess: upload.uploadSuccess,
    setUploadSuccess: upload.setUploadSuccess,
    
    // State from HTML viewer
    viewingFile: htmlViewer.viewingFile,
    loadingFileUrl: htmlViewer.loadingFileUrl,
    
    // Functions
    getDomainName,
    loadFiles: fileStorage.loadFiles,
    handleItemClick,
    handleHTMLFileClick: htmlViewer.handleHTMLFileClick,
    handleNavigateUp: fileStorage.handleNavigateUp,
    handleUploadComplete,
    clearError,
    closeHTMLViewer: htmlViewer.closeHTMLViewer,
    
    // Setters (for backward compatibility)
    setFiles: fileStorage.setFiles,
    setCurrentPath: fileStorage.setCurrentPath,
    setLoading: fileStorage.setLoading,
    setError: fileStorage.setError,
    setActiveTab: tabs.setActiveTab
  };
};
